jQuery(document).on('ready', function(){
	VIMEO.onReady();
});



var VIMEO = {
	onReady: function(){
		jQuery(document).on('click', '.video-play.vimeo', VIMEO.initVIMEO);
		jQuery('.video').on('click', '.close.vimeo', VIMEO.stopVimeo);
	},



	initVIMEO: function(){
		var breakpoint = 768;

		event.preventDefault();
		// VIMEO.context 	= jQuery(this).closest('.video');
		VIMEO.context 	= jQuery(event.target).closest('.video');
		// VIMEO.id 			= jQuery(this).attr('data-vmid');
		VIMEO.id 			= jQuery(VIMEO.context).attr('data-vmid');
		// VIMEO.live 			= jQuery(this).attr('data-vmlive');
		VIMEO.live 			= jQuery(VIMEO.context).attr('data-vmlive');
		VIMEO.container 	= jQuery('.video-container', VIMEO.context);

		// if ( jQuery('body').width() <= breakpoint )
		// 	jQuery('.video').removeClass('is-inline');
		

		if(jQuery('body').hasClass('vimeo-ready')){
			VIMEO.initPlayer();
		} else {
			jQuery.getScript( "https://player.vimeo.com/api/player.js", function(){
				VIMEO.initPlayer();
			}); //API laden
		}	
	},



	initPlayer: function(){
		jQuery(VIMEO.context).addClass('is-playing');
		jQuery(VIMEO.container).addClass('has-ratio');
		jQuery(VIMEO.container).parent().removeClass('is-hidden');

		jQuery('.video-info', VIMEO.context).addClass('is-hidden');
		jQuery('.video-play', VIMEO.context).addClass('is-hidden');
		jQuery('.video .video-sponsor', VIMEO.context).hide('is-hidden');
		jQuery('.video .video-preview', VIMEO.context).css('background-image', '');
		jQuery('.video .close', VIMEO.context).removeClass('youtube').addClass('vimeo');
		jQuery('.video .video-preview', VIMEO.context).hide();
		
		
		if (VIMEO.live == 'true' || VIMEO.live == '1') {
			var options = {
		      	url: 'https://vimeo.com/event/' + VIMEO.id + '/',
		      	autoplay: true
		    };
		} else {
			var options = {
		      	id: VIMEO.id,
		      	autoplay: true
		    };
		}

	    VIMEO.Player = new Vimeo.Player(VIMEO.container, options);

	    VIMEO.Player.setVolume(1);

	    VIMEO.Player.on('play', function() {
	      // console.log('Played Vimeo video');
	    });
	},


	stopVimeo: function(){
	    VIMEO.Player.pause();
	}
}